



















































































































































































































































































































































import { Component, Vue, Watch } from "vue-property-decorator";
import OrderModule from "@/store/order";
import AuthModule from "@/store/auth";
import { asyncMap } from "@/utils/Util";
import { NewOrder, OrderDetail, Menu, OrderType, EachDayTimes, DayTime } from "@/api/api";
// eslint-disable-next-line prettier/prettier
import { RestaurantsApi, MenusApi, OrdersApi } from "@/services/api-service";
import { CartEditStatus } from "@/types";
import moment from "moment";
import { ja } from "vuejs-datepicker/dist/locale";
import TooltipModule from "@/store/tooltip";
import CTooltip from "@/components/CTooltip.vue";
import { Prefectures } from "../../constants";
import FormModal from "./FormModal.vue";

interface DisabledDates {
  to: Date;
  days: number[];
  dates: Date[];
}

@Component({
  components: {
    CTooltip,
    FormModal,
  },
})
export default class CartForm extends Vue {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  private formattedNewOrders: any = [];

  // private termsCheck = false;

  private dayOfWeek = ["sun", "mon", "tue", "wed", "thu", "fri", "sat"];

  private orderableCheck = false;

  private checkedTime = false;

  private timeValidation: DayTime = {
    HH: "",
    mm: "",
  };

  private holidays = [];

  private get me() {
    return AuthModule.me;
  }

  private get OrderType() {
    return OrderType;
  }

  private get newOrders() {
    return OrderModule.newOrders;
  }

  private get newOrder() {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return OrderModule.newOrder as any;
  }

  private get EditStatus() {
    return CartEditStatus;
  }

  private get editStatus() {
    return OrderModule.editStatus;
  }

  private get prefectures() {
    return Prefectures;
  }

  private get moment() {
    return moment;
  }

  private get ja() {
    return ja;
  }

  private get isTooltipShow() {
    return TooltipModule.isShow;
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  private dateSelected(order: any) {
    // eslint-disable-next-line no-param-reassign
    order.deliveryDateTime = {};
    this.timeSelected(order.deliveryDateTime, []);
  }

  private temporaryTimeSelected(selectTime: DayTime) {
    this.timeValidation = selectTime;
  }

  private timeSelected(selectTime: DayTime, restaurantTimes: []) {
    this.timeValidation = selectTime;
    this.checkedTime = false;
    const mathSelectTime = Number(selectTime.HH) * 60 + Number(selectTime.mm);
    restaurantTimes.forEach((dayTimes: EachDayTimes) => {
      const dayTimesEnd = Number(dayTimes.end?.HH) * 60 + Number(dayTimes.end?.mm);
      const dayTimesStart = Number(dayTimes.start?.HH) * 60 + Number(dayTimes.start?.mm);
      if ((dayTimesStart > mathSelectTime || dayTimesEnd < mathSelectTime) && this.checkedTime === false) {
        this.orderableCheck = true;
        this.checkedTime = false;
        if (Number(dayTimes.start?.HH) > Number(dayTimes.end?.HH)) {
          if (
            ((dayTimesStart <= mathSelectTime && mathSelectTime <= 1439) ||
              (mathSelectTime <= dayTimesEnd && mathSelectTime >= 0)) &&
            this.checkedTime === false
          ) {
            this.orderableCheck = false;
            this.checkedTime = true;
          }
        }
        return;
      }
      this.orderableCheck = false;
      this.checkedTime = true;
    });
  }

  private mounted() {
    this.formatOrders();
    OrderModule.commitEditStatus(CartEditStatus.Edit);
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  private sumTotalQuantity(orderDetails: any) {
    let sum = 0;
    orderDetails.forEach((detail: OrderDetail) => {
      sum += detail?.quantity ? detail?.quantity : 0;
    });
    return sum;
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  private sumSubtotalPrice(orderDetails: any[]) {
    let sum = 0;
    orderDetails.forEach((detail: OrderDetail & { menu: Menu }) => {
      sum += detail.menu.price * (detail?.quantity ? detail.quantity : 0);
    });
    return sum;
  }

  @Watch("newOrders")
  private async formatOrders() {
    if (!this.newOrders || !(!this.newOrders || this.newOrders.length > 0)) {
      this.formattedNewOrders = [];
      return;
    }

    /* eslint-disable prettier/prettier */
    this.formattedNewOrders = await asyncMap(
      this.newOrders,
      async (newOrder: NewOrder) => {
        const order = { ...newOrder };
        if (!newOrder.restaurantUuid) {
          throw Error("Restaurant uuid not found");
        }
        if (!order?.orderDetails) {
          throw Error("Failed set orders");
        }
        const restaurant = await this.getRestaurant(newOrder.restaurantUuid);

        const orderDetails = await asyncMap(order.orderDetails, async (orderDetail: OrderDetail) => {
          if (!orderDetail.menuUuid) {
            throw Error("Menu uuid not found");
          }
          const menu = await this.getMenu(orderDetail.menuUuid);

          return { ...orderDetail, menu };
        });

        order.orderDetails = orderDetails;
        order.orderer = {
          phoneNumber: this.me?.phoneNumber,
          name: this.me?.name,
          email: this.me?.email,
        };

        // eslint-disable-next-line prefer-const
        let canOrderType: string[] = [];
        if (restaurant.takeoutable) {
          canOrderType.push(OrderType.Takeout);
        }
        const closedDay: number[] = [];
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const orderableTime: any = {
          mon: [],
          tue: [],
          wed: [],
          thu: [],
          fri: [],
          sat: [],
          sun: [],
        };
        if (restaurant?.edOnlineOrderableTime !== null) {
          Object.entries(restaurant?.edOnlineOrderableTime).forEach(day => {
            if (day[0] === "mon") {
              day[1].forEach((time: EachDayTimes) => {
                if (
                  time.end === null ||
                  time.start === null ||
                  time.end?.HH === "" ||
                  time.start?.HH === "" ||
                  time.end?.mm === "" ||
                  time.start?.mm === ""
                ) {
                  closedDay.push(1);
                } else {
                  // eslint-disable-next-line @typescript-eslint/no-explicit-any
                  const orderTime: any = [];
                  if (Number(time.start?.HH) > Number(time.end?.HH)) {
                    orderableTime.mon.push([time.start?.HH, "23"]);
                    orderableTime.mon.push(["0", time.end?.HH]);
                  } else {
                    orderTime.push(time.start?.HH);
                    orderTime.push(time.end?.HH);
                    orderableTime.mon.push(orderTime);
                  }
                }
              });
            }
            if (day[0] === "tue") {
              day[1].forEach((time: EachDayTimes) => {
                if (
                  time.end === null ||
                  time.start === null ||
                  time.end?.HH === "" ||
                  time.start?.HH === "" ||
                  time.end?.mm === "" ||
                  time.start?.mm === ""
                ) {
                  closedDay.push(2);
                } else {
                  // eslint-disable-next-line @typescript-eslint/no-explicit-any
                  const orderTime: any = [];
                  if (Number(time.start?.HH) > Number(time.end?.HH)) {
                    orderableTime.tue.push([time.start?.HH, "23"]);
                    orderableTime.tue.push(["0", time.end?.HH]);
                  } else {
                    orderTime.push(time.start?.HH);
                    orderTime.push(time.end?.HH);
                    orderableTime.tue.push(orderTime);
                  }
                }
              });
            }
            if (day[0] === "wed") {
              day[1].forEach((time: EachDayTimes) => {
                if (
                  time.end === null ||
                  time.start === null ||
                  time.end?.HH === "" ||
                  time.start?.HH === "" ||
                  time.end?.mm === "" ||
                  time.start?.mm === ""
                ) {
                  closedDay.push(3);
                } else {
                  // eslint-disable-next-line @typescript-eslint/no-explicit-any
                  const orderTime: any = [];
                  if (Number(time.start?.HH) > Number(time.end?.HH)) {
                    orderableTime.wed.push([time.start?.HH, "23"]);
                    orderableTime.wed.push(["0", time.end?.HH]);
                  } else {
                    orderTime.push(time.start?.HH);
                    orderTime.push(time.end?.HH);
                    orderableTime.wed.push(orderTime);
                  }
                }
              });
            }
            if (day[0] === "thu") {
              day[1].forEach((time: EachDayTimes) => {
                if (
                  time.end === null ||
                  time.start === null ||
                  time.end?.HH === "" ||
                  time.start?.HH === "" ||
                  time.end?.mm === "" ||
                  time.start?.mm === ""
                ) {
                  closedDay.push(4);
                } else {
                  // eslint-disable-next-line @typescript-eslint/no-explicit-any
                  const orderTime: any = [];
                  if (Number(time.start?.HH) > Number(time.end?.HH)) {
                    orderableTime.thu.push([time.start?.HH, "23"]);
                    orderableTime.thu.push(["0", time.end?.HH]);
                  } else {
                    orderTime.push(time.start?.HH);
                    orderTime.push(time.end?.HH);
                    orderableTime.thu.push(orderTime);
                  }
                }
              });
            }
            if (day[0] === "fri") {
              day[1].forEach((time: EachDayTimes) => {
                if (
                  time.end === null ||
                  time.start === null ||
                  time.end?.HH === "" ||
                  time.start?.HH === "" ||
                  time.end?.mm === "" ||
                  time.start?.mm === ""
                ) {
                  closedDay.push(5);
                } else {
                  // eslint-disable-next-line @typescript-eslint/no-explicit-any
                  const orderTime: any = [];
                  if (Number(time.start?.HH) > Number(time.end?.HH)) {
                    orderableTime.fri.push([time.start?.HH, "23"]);
                    orderableTime.fri.push(["0", time.end?.HH]);
                  } else {
                    orderTime.push(time.start?.HH);
                    orderTime.push(time.end?.HH);
                    orderableTime.fri.push(orderTime);
                  }
                }
              });
            }
            if (day[0] === "sat") {
              day[1].forEach((time: EachDayTimes) => {
                if (
                  time.end === null ||
                  time.start === null ||
                  time.end?.HH === "" ||
                  time.start?.HH === "" ||
                  time.end?.mm === "" ||
                  time.start?.mm === ""
                ) {
                  closedDay.push(6);
                } else {
                  // eslint-disable-next-line @typescript-eslint/no-explicit-any
                  const orderTime: any = [];
                  if (Number(time.start?.HH) > Number(time.end?.HH)) {
                    orderableTime.sat.push([time.start?.HH, "23"]);
                    orderableTime.sat.push(["0", time.end?.HH]);
                  } else {
                    orderTime.push(time.start?.HH);
                    orderTime.push(time.end?.HH);
                    orderableTime.sat.push(orderTime);
                  }
                }
              });
            }
            if (day[0] === "sun") {
              day[1].forEach((time: EachDayTimes) => {
                if (
                  time.end === null ||
                  time.start === null ||
                  time.end?.HH === "" ||
                  time.start?.HH === "" ||
                  time.end?.mm === "" ||
                  time.start?.mm === ""
                ) {
                  closedDay.push(0);
                } else {
                  // eslint-disable-next-line @typescript-eslint/no-explicit-any
                  const orderTime: any = [];
                  if (Number(time.start?.HH) > Number(time.end?.HH)) {
                    orderableTime.sun.push([time.start?.HH, "23"]);
                    orderableTime.sun.push(["0", time.end?.HH]);
                  } else {
                    orderTime.push(time.start?.HH);
                    orderTime.push(time.end?.HH);
                    orderableTime.sun.push(orderTime);
                  }
                }
              });
            }
          });
        }
        const deliveryDate = new Date();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const getHolidays: any = restaurant.restaurantHolidays?.map(obj => obj.day);
        if (getHolidays) {
          this.holidays = getHolidays.map((value: string) => new Date(value));
        }
        const disabledDates = {
          to: new Date(deliveryDate.getFullYear(), deliveryDate.getMonth(), deliveryDate.getDate()),
          days: closedDay,
          dates: this.holidays,
        };
        const deliveryDateTime = {
          // mm: moment().format("mm"),
          // HH: (0 + String(Number(moment().format("HH")) + 1)).slice(-2),
        };
        return { ...order, restaurant, canOrderType, deliveryDate, deliveryDateTime, disabledDates, orderableTime };
      }
      /* eslint-enable */
    );
  }

  /**
   * 定休日かチェック
   */
  private checkHoliday(deliveryDate: Date, disabledDates: DisabledDates) {
    console.log("deliveryDate", deliveryDate);
    console.log(
      disabledDates.days.some(day => {
        console.log("day day", day);
        return day === deliveryDate.getDay();
      }) ||
        disabledDates.dates.some(date => {
          console.log("value", date);

          const disabledDate = `${date.getFullYear()}/${date.getMonth()}/${date.getDate()}`;
          const currentDate = `${deliveryDate.getFullYear()}/${deliveryDate.getMonth()}/${deliveryDate.getDate()}`;
          console.log("disabledDate", disabledDate);
          console.log("currentDate", currentDate);
          return disabledDate === currentDate;
        })
    );
    console.log("disabledDates", disabledDates);
    return (
      disabledDates.days.some(value => value === deliveryDate.getDay()) ||
      disabledDates.dates.some(value => {
        const disabledDate = `${value.getFullYear()}/${value.getMonth()}/${value.getDate()}`;
        const currentDate = `${deliveryDate.getFullYear()}/${deliveryDate.getMonth()}/${deliveryDate.getDate()}`;
        return disabledDate === currentDate;
      })
    );
  }

  private async getRestaurant(uuid: string) {
    try {
      // eslint-disable-next-line prettier/prettier
      const restaurantRes = await RestaurantsApi.instance.gerRestaurantByUuid(uuid);
      if (!restaurantRes.data.data?.restaurant) {
        throw Error("Restaurant not found");
      }
      return restaurantRes.data.data?.restaurant;
    } catch (err) {
      console.log(err);
      throw err;
    }
  }

  private async getMenu(uuid: string) {
    try {
      // eslint-disable-next-line prettier/prettier
      const menuRes = await MenusApi.instance.getMenuByUuid(uuid);
      if (!menuRes.data.data?.menu) {
        throw Error("Menu not found");
      }
      return menuRes.data.data?.menu;
    } catch (err) {
      console.log(err);
      throw err;
    }
  }

  private addressEdit(order: Partial<NewOrder>, deliveryDateTime: DayTime) {
    if (
      !order?.orderType ||
      this.orderableCheck ||
      this.timeValidation.HH === "" ||
      this.timeValidation.mm === "" ||
      deliveryDateTime.HH === "" ||
      deliveryDateTime.mm === "" ||
      !this.timeValidation.HH ||
      !this.timeValidation.mm
    ) {
      TooltipModule.commitIsShow(true);
      setTimeout(() => {
        TooltipModule.commitIsShow(false);
      }, 3000);
      return;
    }
    const defaultAddress = {
      postalCode: "",
      prefecture: "",
      city: "",
      addressLine1: "",
      addressLine2: null,
    };
    OrderModule.commitNewOrder(
      Object.assign(order, {
        shippingAddress: this.me?.address ? this.me?.address : defaultAddress,
      })
    );
    OrderModule.commitEditStatus(CartEditStatus.AddressEdit);
  }

  private clickDecrease(menu: Menu & { amount: number }) {
    if (menu.amount > 0) {
      // eslint-disable-next-line no-param-reassign
      menu.amount -= 1;
    }
  }

  // - TODO: radio value チェック
  private confirm() {
    OrderModule.commitEditStatus(CartEditStatus.Confirm);
  }

  private backEdit() {
    OrderModule.commitEditStatus(CartEditStatus.Edit);
  }

  private backAddressEdit() {
    OrderModule.commitEditStatus(CartEditStatus.AddressEdit);
  }

  private async submit() {
    if (!this.newOrder) {
      return;
    }
    try {
      const buildedDesiredDeliveryTime = moment(this.newOrder.deliveryDate)
        .set("hour", this.newOrder.deliveryDateTime.HH)
        .set("minute", this.newOrder.deliveryDateTime.mm);
      const newOrder = Object.assign(this.newOrder, {
        deliveryDate: buildedDesiredDeliveryTime,
      });
      // eslint-disable-next-line
      const orderRes = await OrdersApi.instance.createOrder(newOrder);
      OrderModule.commitNewOrders([]);
      OrderModule.commitNewOrder(null);
    } catch (err) {
      console.log(err);
    }
  }

  private removeItem(orderDetail: OrderDetail & { menu: Menu }) {
    OrderModule.commitRemoveOrderDetail(orderDetail);
  }

  // ここからモーダル//
  private testShow() {
    (this.$refs.test as FormModal).CtestShow();
    this.submit();
    // if (this.termsCheck) {
    // }
  }

  private showModal(name: string) {
    this.$modal.show(`${name}`);
  }

  private closeModal(name: string) {
    this.$modal.hide(name);
  }
  // ここまでモーダル//
}
